import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';
import { DefaultModalComponents } from '../../ProjectModal/utils';
import AppCSS from '../../../utils/styled';
import { Form } from 'formik';
import Checkbox from '@mui/material/Checkbox';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-arrow-down.svg';

export const Components = {
  ...DefaultModalComponents,
  FormButtonsContainer: styled.div`
    padding-top: 28px;
    width: 100%;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  PrimaryButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    min-width: max-content;
    padding: 10px 16px;
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.white};
    background-color: ${AppCSS.colors.blues.dark};
    border: none;
    cursor: pointer;
  `,
  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,

  Form: styled(Form)`
    width: 100%;
  `,

  FieldsWrapper: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 3px calc(100% - 11px);
    grid-column-gap: 8px;
  `,
  FieldsContent: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldStartAdornment: styled.div<{ variant: 'minimal' | 'readyToPlay' | 'additional' }>`
    min-height: 24px;
    height: auto;
    width: 3px;
    ${AppCSS.radiuses.small};
    background-color: ${({ variant }) => {
      switch (variant) {
        case 'minimal':
          return AppCSS.colors.red;
        case 'readyToPlay':
          return AppCSS.colors.orange;
        case 'additional':
          return AppCSS.colors.greys.darker;
      }
    }};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  FieldLabelBigger: styled.span`
    ${AppCSS.fonts.label14Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  FieldBasic: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  LengthInputsWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,

  CheckboxFieldWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    margin: 12px 0;
  `,

  Checkbox: styled(Checkbox)`
    &.Mui-checked {
      color: ${AppCSS.colors.blues.dark} !important;
    }
    color: ${AppCSS.colors.blues.veryLight};
    width: 20px;
    height: 20px;
  `,
  CheckboxLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  InputMenu: styled.input`
    visibility: visible;
    width: 0;
    margin-right: -8px;
  `,
  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: transparent;
    overflow: hidden;
    width: 100%;
    padding: 12px;
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    flex: 1;
  `,

  UploadFileWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
  `,

  UploadButton: styled.label`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,

  ClearButton: styled.div`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    cursor: pointer;
  `,
};
